export type DataTableConfig = typeof dataTableConfig;

export const dataTableConfig = {
	comparisonOperators: [
		{ label: "Contiene", value: "ilike" as const },
		{ label: "No contiene", value: "notIlike" as const },
		{ label: "Es igual a", value: "eq" as const },
		{ label: "No es igual a", value: "notEq" as const },
		{ label: "Empieza con", value: "startsWith" as const },
		{ label: "Termina con", value: "endsWith" as const },
		{ label: "Es vacío", value: "isNull" as const },
		{ label: "No es vacío", value: "isNotNull" as const },
	],
	selectableOperators: [
		{ label: "Es igual a", value: "eq" as const },
		{ label: "No es igual a", value: "notEq" as const },
		{ label: "Es vacío", value: "isNull" as const },
		{ label: "No es vacío", value: "isNotNull" as const },
	],
	logicalOperators: [
		{
			label: "Y",
			value: "and" as const,
			description: "Todos los criterios deben cumplirse",
		},
		{
			label: "O",
			value: "or" as const,
			description: "Al menos uno de los criterios debe cumplirse",
		},
	],
};

export const dataTableConfigExperimental = {
	textOperators: [
		{ label: "Contenga", value: "iLike" as const },
		{ label: "No contenga", value: "notILike" as const },
		{ label: "Es", value: "eq" as const },
		{ label: "No es", value: "ne" as const },
		{ label: "Esta vacio", value: "isEmpty" as const },
		{ label: "No esta vacio", value: "isNotEmpty" as const },
	],
	numericOperators: [
		{ label: "Es", value: "eq" as const },
		{ label: "No es", value: "ne" as const },
		{ label: "Es menor que", value: "lt" as const },
		{ label: "Es menor o igual que", value: "lte" as const },
		{ label: "Es mayor a", value: "gt" as const },
		{ label: "Es mayor o igual que", value: "gte" as const },
		{ label: "Esta vacio", value: "isEmpty" as const },
		{ label: "No esta vacio", value: "isNotEmpty" as const },
	],
	dateOperators: [
		{ label: "Es", value: "eq" as const },
		{ label: "No es", value: "ne" as const },
		{ label: "Es antes", value: "isBefore" as const },
		{ label: "Es despues", value: "isAfter" as const },
		{ label: "Es antes o igual", value: "isOnOrBefore" as const },
		{ label: "Es despues o igual", value: "isOnOrAfter" as const },
		{ label: "Es entre", value: "isBetween" as const },
		{ label: "Es relativo a hoy", value: "isRelativeToToday" as const },
		{ label: "Es vacío", value: "isEmpty" as const },
		{ label: "No es vacío", value: "isNotEmpty" as const },
	],
	selectOperators: [
		{ label: "Es", value: "eq" as const },
		{ label: "No es", value: "ne" as const },
		{ label: "Esta vacio", value: "isEmpty" as const },
		{ label: "No esta vacio", value: "isNotEmpty" as const },
	],
	booleanOperators: [
		{ label: "Es", value: "eq" as const },
		{ label: "No es", value: "ne" as const },
	],
	joinOperators: [
		{ label: "Y", value: "and" as const },
		{ label: "O", value: "or" as const },
	],
	globalOperators: [
		"iLike",
		"notILike",
		"eq",
		"ne",
		"isEmpty",
		"isNotEmpty",
		"lt",
		"lte",
		"gt",
		"gte",
		"isBefore",
		"isAfter",
		"isOnOrBefore",
		"isOnOrAfter",
		"isBetween",
		"isRelativeToToday",
		"and",
		"or",
	] as const,
	columnTypes: [
		"text",
		"number",
		"date",
		"boolean",
		"select",
		"multi-select",
	] as const,
};

export type DataTableConfigExperimental = typeof dataTableConfigExperimental;
